import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionTimeSpendPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionTimeSpend.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionTimeSpend.button1'),
          value: '15_minutes_or_less',
        },
        {
          text: t('pages.onboarding.questionTimeSpend.button2'),
          value: '30_minutes',
        },
        {
          text: t('pages.onboarding.questionTimeSpend.button3'),
          value: '45_minutes',
        },
        {
          text: t('pages.onboarding.questionTimeSpend.button4'),
          value: '1_hour_or_more',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
